import React from 'react'
import { useIntl } from 'react-intl'
import pkg from 'package'
import Modal from 'modals/dialog'
import { /*Layout, HeaderRow, Heading, CloseButton,*/ Iframe } from './s'

const FeatureRoadmapModalDumbContent = () => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal.Header
                heading={formatMessage({
                    id: 'noun_feature_roadmap',
                    defaultMessage: 'Feature road map'
                })}
                size="huge"
                caption={formatMessage({
                    id: 'feature_roadmap_information',
                    defaultMessage: 'Click any card to add your vote.'
                })} />
            <Modal.Body className="fullbleed compact-end">
                <Iframe src={`https://portal.productboard.com/${pkg.thirdPartyApps.productboard}/`} />
            </Modal.Body>
        </>
    )
}

export default FeatureRoadmapModalDumbContent